import { render } from "./BotaoTopo.vue?vue&type=template&id=9c5ca1c8&scoped=true&ts=true"
import script from "./BotaoTopo.vue?vue&type=script&lang=ts"
export * from "./BotaoTopo.vue?vue&type=script&lang=ts"

import "./BotaoTopo.vue?vue&type=style&index=0&id=9c5ca1c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c5ca1c8"]])

export default __exports__